"use client";

import { type ComponentPropsWithRef, useRef } from "react";
import { cn } from "@/lib/utils";
import { usePageStickyHeader } from "./use-page-sticky-header";

/** 分析ページの列見出しを固定する。ページ外のダイアログや設定表は通常の見出しを保つ。 */
export function TableHeader({
  className,
  ref,
  ...props
}: ComponentPropsWithRef<"thead">) {
  const headRef = useRef<HTMLTableSectionElement>(null);
  usePageStickyHeader(headRef);
  return (
    <thead
      ref={(element) => {
        headRef.current = element;
        if (typeof ref === "function") return ref(element);
        if (ref) ref.current = element;
      }}
      className={cn("[&_tr]:border-b", className)}
      {...props}
    />
  );
}
